<div class="row">
  <div class="col-12" [ngClass]="{'col-md-6': budgetFund?.length==1,'col-md-12': budgetFund?.length>1}">
      <h1 class="page-header "><i class="fas fa-file-invoice-dollar"></i> Resumen por Departamento</h1>

  </div>
  @if(budgetFund?.length>1){
  <div class="col-12  mb-3" [ngClass]="{'col-md-6': budgetFund?.length>1}">

      <div class="btn-group">
          @for(f of budgetFund; track f.id){
          <button class="btn btn-white btn-sm" [ngStyle]="{'min-width': '120px'}"
              [class.active]="fundSelect ==f.fundCode" (click)="changeFund(f.fundCode)">Fondo {{f.fundCode}}</button>
          }
      </div>
  </div>
  }
  <div class="col-12 mb-3 col-md-6">
    <div class=" d-md-flex fw-bold justify-content-end">
        <div class="mt-3">
            <div class="ms-md-4 mt-md-0 mt-e dropdown-toggle">
              @if(departament?.length>0){
                <a href="javascript:;"
                    class="text-decoration-none text-dark text-opacity-75"
                    (click)="exportPDF()"><i
                        class="fa fa-print fa-fw me-1 text-dark text-opacity-50"></i> Imprimir</a>}
            </div>
        </div>
    </div>
</div>
</div>

<app-budget-over-view [data]="items" [filterItemCode]="undefined" [departament]="undefined"
[fundCode]="fundSelect"></app-budget-over-view>






<div class="panel p-4">
  <div class="table-responsive  mt-2">
    @if(entitySelected?.group=='IASD'){
      <table class="table table-sm ">
        <thead>
          <tr>
            <th class="text-nowrap" style="width: 100px;">
              <a class="me-2 ms-2 text-dark"
                 [ngbTooltip]="isAllCollapsedIASD ? 'Expandir todo' : 'Ocultar todo'"
                 placement="bottom"
                 [container]="'body'"
                 (click)="toggleAllCollapseIASD()">
                <i class="fas fa-xs" [ngClass]="isAllCollapsedIASD ? 'fa-plus' : 'fa-minus'"></i>
              </a>
              Código
            </th>
            <th>Departamento</th>
            @for (item of fieldName; track i+item.itemCode; let i = $index){
              <th class="text-end">Asignado {{item.departamentDisplayName}}</th>
            }
            <th class="text-end">Asignación Total</th>
          </tr>
        </thead>
    
        @for (group of groupedDepartments; track group.itemCode) {
          <!-- Cabecera del grupo -->
          <thead>
            <tr class="bg-light fw-bold">
              <th [attr.colspan]="2" class="align-middle" style="height: 35px;">
                <!-- Botón de expandir/colapsar -->
                <a class="me-2 ms-2 text-dark"
                [ngbTooltip]="isCollapsedIASD(group) ? 'Expandir' : 'Ocultar'"
                placement="bottom"  [container]="'body'"
                (click)="toggleCollapseIASD(group.itemCode)">
               <i class="fas fa-xs" [ngClass]="isCollapsedIASD(group) ? 'fa-plus' : 'fa-minus'"></i>
             </a>
             
                {{ group.itemDisplayName }}
              </th>
    
              @for (f of fieldName; track i; let i = $index){
                <td class="align-middle text-end">
                  $ {{ getValueExpenseDepartamentFund(group.itemCode,f.departamentCode) | number:'1.0-0' }}
                </td>
              }
    
              <th class="align-middle text-end ">
                $ {{ getGroupTotal(group) | number: '1.0-0' }}
              </th>
            </tr>
          </thead>
    
          <!-- Filas detalle (solo si NO está colapsado) -->
          @if(!isCollapsedIASD(group)){
          <tbody>
            @for (sub of group.departments; track sub.departamentCode) {
              @if(sub.departamentCode=='-1'&&sub.total>0||sub.departamentCode!='-1'){
              <tr [ngClass]="{'custom-table-warning': sub.departamentCode == '-1'}">
                <td class="text-nowrap align-middle"
                    [ngClass]="{'text-danger ': sub.departamentCode == '-1'}"
                    style="height: 35px;">
                  @if(sub.departamentCode == '-1'){
                    <div class="text-danger fw-bold">
                      <i class="fa fa-exclamation-circle text-danger fs-8px"></i>
                      Asignar departamento - Tabulación de Sueldo
                    </div>
                  } @else {
                    {{ sub.departamentCode }} 
                  }
                </td>
    
                <td class="align-middle text-start"
                    [ngClass]="{'text-danger': sub.departamentCode == '-1'}">
                  {{ sub.departamentDisplayName }}
                </td>
    
                @for (f of fieldName; track i; let i = $index){
                  <td class="align-middle text-end"
                      [ngClass]="{'text-danger': sub.departamentCode == '-1'}">
                    $ {{ getDepartamentValueIASD(sub,f.departamentCode)|number:'1.0-0' }}
                  </td>
                }
    
                <td class="align-middle text-end"
                    [ngClass]="{'text-danger': sub.departamentCode == '-1'}">
                  $ {{ sub.total|number:'1.0-0' }}
                </td>
              </tr>
              }
            }
          </tbody>
          }
        }
      </table>
    }
    @else {
      <table class="table table-sm">
        <thead class="sticky-header">
          <!-- Primera fila sticky: Encabezados generales -->
          <tr class="first-header bg-light">
            <th class="text-nowrap align-middle" style="width: 200px;">
              <a class="me-2 ms-2 text-dark" [container]="'body'"
                 [ngbTooltip]="isAllCollapsed ? 'Expandir todos' : 'Ocultar todos'"
                 placement="bottom"
                 (click)="toggleAllCollapse()">
                <i class="fas fa-xs" [ngClass]="isAllCollapsed ? 'fa-plus' : 'fa-minus'"></i>
              </a> Departamentos
            </th>
              @for (item of factorRea; track item.itemCode) {
                @if (item.itemCode != 500) {
                <th class="text-end text-nowrap align-middle">{{ item.shortName }}</th>
              }
            }
            <th class="text-end text-nowrap align-middle">Margen (Ingresos - Egresos)</th>
          </tr>
        </thead>
      
        <tbody>
          @for (parentGroup of groupedByParentThenItem; track parentGroup.departamentParentCode) {
            <!-- Fila resumen del grupo: usar sticky vía CSS -->
            <tr class="second-header bg-light fw-bold">
              <td class="text-nowrap bg-light" style="z-index: 5;">
                <a class="me-2 ms-2 text-dark" [container]="'body'"
                   [ngbTooltip]="isCollapsed(parentGroup) ? 'Expandir' : 'Ocultar'"
                   placement="bottom"
                   (click)="toggleCollapse(parentGroup.departamentParentCode)">
                  <i class="fas fa-xs" [ngClass]="isCollapsed(parentGroup) ? 'fa-plus' : 'fa-minus'"></i>
                </a>
                {{ parentGroup.departamentParentName }}
              </td>
              @for (item of factorRea; track item.itemCode) {
                @if(item.itemCode!=500){
                <td class="text-end text-nowrap bg-light"
                    [ngClass]="{
                      'text-danger': item.name === 'expense' && getGroupTotalParam(parentGroup.items,item) > 0
                    }">
                  $ {{ item.name === 'expense' && getGroupTotalParam(parentGroup.items,item) > 0 ? '-' : '' }}
                  {{ getGroupTotalParam(parentGroup.items,item) | number: '1.0-0' }}
                </td>
                }
              }
              <td class="text-end fw-bold text-nowrap bg-light"
                  [ngClass]="{'text-danger': getParentGroupMargin(parentGroup) < 0}">
                $ {{ getParentGroupMargin(parentGroup) | number: '1.0-0' }}
              </td>
            </tr>
      
            <!-- Filas detalle -->
            @if (!isCollapsed(parentGroup)) {
              @for (dep of parentGroup.items[0]?.departments; track dep.departamentCode) {
                <tr [ngClass]="{'custom-table-warning': dep.departamentCode == '-1'}">
                  @if(dep.departamentCode == '-1'){
                  <td class="text-nowrap text-danger"><i class="fa fa-exclamation-circle"></i> Asignar departamento</td>
                  }
                  @else{
                  <td class="text-nowrap">{{dep.departamentCode}} - {{ dep.departamentDisplayName }}</td>
                  }
                  @for (item of factorRea; track item.itemCode) {
                    @if (item.itemCode != 500) {
                    <td class="text-end text-nowrap"
                    [ngClass]="{
                      'text-danger': item.name === 'expense' &&
                                     getDepartamentValue(dep.departamentCode,item.itemCode)?.total > 0
                    }">
                  $ {{ item.name === 'expense' && getDepartamentValue(dep.departamentCode,item.itemCode)?.total > 0 ? '-' : '' }}{{ getDepartamentValue(dep.departamentCode,item.itemCode)?.total|number: '1.0-0' }}
                </td>
                  }
                }
                  <td class="text-end fw-bold"
                      [class.text-danger]="getTotalByDepartment(parentGroup, dep.departamentCode) < 0">
                    $ 
                    {{ getTotalByDepartment(parentGroup, dep.departamentCode) | number: '1.0-0' }}
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
         
    }
</div>
</div>

@if(entitySelected?.group=='IASD'){

  @for (group of groupedDepartments; track group.itemCode) {
  <table class="table table-sm hide" id="table-departament-{{group.itemCode}}">
    <thead>
      <tr>
        <th class="align-middle bg-light" >
          {{ group.itemDisplayName }}
        </th>
        <th  [attr.colspan]="fieldName?.length+1" class="align-middle bg-light" >
        </th>
      </tr>
    </thead>

    <!-- Filas detalle -->
    <tbody>
      @for (sub of group.departments; track sub.departamentCode) {
        @if(sub.departamentCode=='-1'&&sub.total>0||sub.departamentCode!='-1'){
        <tr [ngClass]="{'custom-table-warning': sub.departamentCode == '-1'}">
          <td class="text-nowrap align-middle"
              [ngClass]="{'text-danger fw-bold': sub.departamentCode == '-1'}"
              style="height: 35px;">

            @if(sub.departamentCode == '-1'){
              <div class="text-danger fw-bold">
                <i class="fa fa-exclamation-circle text-danger fs-8px"></i>
                Asignar departamento - Tabulación de Sueldo
              </div>
            } @else {
              {{ sub.departamentCode }} - {{ capitalize(sub.departamentDisplayName) }}
            }
          </td>
          @for (f of fieldName; track i; let i = $index){
            <td class="align-middle text-end"
                [ngClass]="{'text-danger': sub.departamentCode == '-1'}">
              $ {{ getDepartamentValueIASD(sub,f.departamentCode) | number:'1.0-0' }}
            </td>
          }

          <td class="align-middle text-end"
              [ngClass]="{'text-danger': sub.departamentCode == '-1'}">
            $ {{ sub.total | number:'1.0-0' }}
          </td>
        </tr>
        }
      }
    </tbody>
    <tfoot>
      <tr>
        <td class="align-middle bg-light" >
          Subtotal
        </td>
        @for (f of fieldName; track i; let i = $index){
          <td class="align-middle text-end">
            $ {{ getValueExpenseDepartamentFund(group.itemCode,f.departamentCode) | number:'1.0-0' }}
          </td>
        }
        <td class="align-middle bg-light text-end" >
          $ {{ getGroupTotal(group) | number:'1.0-0' }}
        </td>
      </tr>
    </tfoot>
  </table>
  }

}
@else if(entitySelected?.group=='FUNDACION') {
<!-- Tabla global opcional -->



@for (parentGroup of groupedByParentThenItem; track parentGroup.departamentParentCode) {
  
  <table class="table table-sm hide " id="table-departament-{{parentGroup.departamentParentCode}}">
    <!-- Cabecera del grupo -->
    <thead>
      <tr class="second-header bg-light fw-bold">
        <td class="text-nowrap bg-light" style="z-index: 5;">{{ parentGroup.departamentParentName }}</td>
        <td [attr.colspan]="factorRea?.length" class="text-end text-nowrap bg-light"></td>

      </tr>

    </thead>

    <!-- Filas detalle del grupo -->
    <tbody>
      @for (dep of parentGroup.items[0]?.departments; track dep.departamentCode) {
        <tr [ngClass]="{'custom-table-warning': dep.departamentCode == '-1'}">
          @if(dep.departamentCode == '-1'){
            <td class="text-nowrap text-danger">
              <i class="fa fa-exclamation-circle"></i> Asignar departamento
            </td>
          }
          @else{
            <td class="text-nowrap">{{ dep.departamentCode }} - {{ dep.departamentDisplayName }}</td>
          }
          @for (item of factorRea; track item.itemCode) {
            @if (item.itemCode != 500) {
            <td class="text-end text-nowrap"
            [ngClass]="{
              'text-danger': item.name === 'expense' &&
                             getDepartamentValue(dep.departamentCode,item.itemCode)?.total > 0
            }">
          $ {{ item.name === 'expense' && getDepartamentValue(dep.departamentCode,item.itemCode)?.total > 0 ? '-' : '' }}{{ getDepartamentValue(dep.departamentCode,item.itemCode)?.total|number: '1.0-0' }}
        </td>
          }
        }
          <td class="text-end fw-bold"
              [class.text-danger]="getTotalByDepartment(parentGroup, dep.departamentCode) < 0">
            $ 
            {{ getTotalByDepartment(parentGroup, dep.departamentCode) | number: '1.0-0' }}
          </td>
        </tr>
      }
    </tbody>
    <tfoot> 
      <tr class="second-header bg-light fw-bold">
        <td class="text-nowrap bg-light" style="z-index: 5;">Subtotal</td>
        @for (item of factorRea; track item.itemCode) {
                @if(item.itemCode!=500){
                <td class="text-end text-nowrap bg-light"
                    [ngClass]="{
                      'text-danger': item.name === 'expense' && getGroupTotalParam(parentGroup.items,item) > 0
                    }">
                  $ {{ item.name === 'expense' && getGroupTotalParam(parentGroup.items,item) > 0 ? '-' : '' }}
                  {{ getGroupTotalParam(parentGroup.items,item) | number: '1.0-0' }}
                </td>
                }
              }
              <td class="text-end fw-bold text-nowrap bg-light"
                  [ngClass]="{'text-danger': getParentGroupMargin(parentGroup) < 0}">
                $ {{ getParentGroupMargin(parentGroup) | number: '1.0-0' }}
              </td>
      </tr>
    </tfoot>
  </table>
}

}
@else {
<!-- Tabla global opcional -->



@for (parentGroup of groupedByParentThenItem; track parentGroup.departamentParentCode) {
  
  <table class="table table-sm hide" id="table-departament-{{parentGroup.departamentParentCode}}">
    <!-- Cabecera del grupo -->
    <thead>
      <tr class="second-header bg-light fw-bold">
        <td class="text-nowrap bg-light" style="z-index: 5;">{{ parentGroup.departamentParentName }}</td>
        <td [attr.colspan]="factorRea?.length" class="text-end text-nowrap bg-light"></td>

      </tr>

    </thead>

    <!-- Filas detalle del grupo -->
    <tbody>
      @for (dep of parentGroup.items[0]?.departments; track dep.departamentCode) {
        <tr [ngClass]="{'custom-table-warning': dep.departamentCode == '-1'}">
          @if(dep.departamentCode == '-1'){
            <td class="text-nowrap text-danger">
              <i class="fa fa-exclamation-circle"></i> Asignar departamento
            </td>
          }
          @else{
            <td class="text-nowrap">{{ dep.departamentCode }} - {{ dep.departamentDisplayName }}</td>
          }
          @for (item of factorRea; track item.itemCode) {
            @if (item.itemCode != 500) {
            <td class="text-end text-nowrap"
            [ngClass]="{
              'text-danger': item.name === 'expense' &&
                             getDepartamentValue(dep.departamentCode,item.itemCode)?.total > 0
            }">
          $ {{ item.name === 'expense' && getDepartamentValue(dep.departamentCode,item.itemCode)?.total > 0 ? '-' : '' }}{{ getDepartamentValue(dep.departamentCode,item.itemCode)?.total|number: '1.0-0' }}
        </td>
          }
        }
          <td class="text-end fw-bold"
              [class.text-danger]="getTotalByDepartment(parentGroup, dep.departamentCode) < 0">
            $ 
            {{ getTotalByDepartment(parentGroup, dep.departamentCode) | number: '1.0-0' }}
          </td>
        </tr>
      }
    </tbody>
    <tfoot> 
      <tr class="second-header bg-light fw-bold">
        <td class="text-nowrap bg-light" style="z-index: 5;">Subtotal</td>
        @for (item of factorRea; track item.itemCode) {
                @if(item.itemCode!=500){
                <td class="text-end text-nowrap bg-light"
                    [ngClass]="{
                      'text-danger': item.name === 'expense' && getGroupTotalParam(parentGroup.items,item) > 0
                    }">
                  $ {{ item.name === 'expense' && getGroupTotalParam(parentGroup.items,item) > 0 ? '-' : '' }}
                  {{ getGroupTotalParam(parentGroup.items,item) | number: '1.0-0' }}
                </td>
                }
              }
              <td class="text-end fw-bold text-nowrap bg-light"
                  [ngClass]="{'text-danger': getParentGroupMargin(parentGroup) < 0}">
                $ {{ getParentGroupMargin(parentGroup) | number: '1.0-0' }}
              </td>
      </tr>
    </tfoot>
  </table>
}

}


       








<ng-template #modal_account let-c="close" let-d="dismiss" let-modal>
    <div class="modal-header">
        <h5 class="modal-title">tabla draggrag</h5>
        <button (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="7">
            <span>&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <app-setting-field-salary></app-setting-field-salary>

    </div>

</ng-template>



  <!--modal diverse-->

  <ng-template #preview let-c="close" let-d="dismiss" let-modal>

    <div class="modal-header">
         <a [href]="pdfSrc" class="btn btn-success btn-sm" target="_blank">Abrir en nueva pestaña</a>
        <span (click)="d('Cross click')" type="button" class="btn-close bt-xs" data-dismiss="modal" tabindex="8">
        </span>
    </div>
    <div class="modal-body">
        <iframe *ngIf="pdfSrc" [src]="pdfSrc" width="100%" height="600px"></iframe>
    </div>

</ng-template>
<!--end diverse-->